import { types } from "../../../types/types";

const initialState = {
    data: [],
    loading: false,
    documentacionPorSubTipoEfectores: null
};

export const TipoDocumentacionesEfectorReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.abmTraerTipoDocumentacionesEfectores:
            return {
                ...state,
                loading: true
            }
        case types.abmTraerTipoDocumentacionesEfectoresSuccess:
            return {
                ...state,
                data: action.payload,
                loading: false
            }
        case types.abmTraerTipoDocumentacionesEfectoresError:
            return {
                ...state,
                data: [],
                loading: false
            }
        case types.abmFiltrarTipoDocumentacionesEfectores:
            return {
                ...state,
                data: action.payload
            }
        case types.tipoDocumentacionPorSubTipoEfectorLimpiar:
            return {
                ...state,
                documentacionPorSubTipoEfectores: null
            }
        case types.tipoDocumentacionPorSubTipoEfector:
            return {
                ...state,
                loading: true
            }
        case types.tipoDocumentacionPorSubTipoEfectorTraerSuccess:
            return {
                ...state,
                documentacionPorSubTipoEfectores: action.payload,
                loading: false
            }
        case types.tipoDocumentacionPorSubTipoEfectorTraerError:
            return {
                ...state,
                documentacionPorSubTipoEfectores: null,
                loading: false
            }
        case types.tipoDocumentacionPorSubTipoEfectorCrear:
            return {
                ...state,
                documentacionPorSubTipoEfectores: action.payload
            }
        case types.tipoDocumentacionPorSubTipoEfectorModificar:
            let list1=state.documentacionPorSubTipoEfectores.filter(e=>e.idTipoDocumentacionesEfectoresPorSubTipoEfector !== action.payload.idTipoDocumentacionesEfectoresPorSubTipoEfector)
            return {
                ...state,
                documentacionPorSubTipoEfectores: [...list1, action.payload]
            }
        case types.tipoDocumentacionPorSubTipoEfectorEliminar:
            let list2=state.documentacionPorSubTipoEfectores.filter(e=>e.idTipoDocumentacionesEfectoresPorSubTipoEfector !== action.payload)
            return {
                ...state,
                documentacionPorSubTipoEfectores: list2
            }
        default:
            return state;
    }
};
